import { API_ROUTE_ADMIN_TELE_POLICIES } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { SalaryDeductionProfileOriginal } from './type'

const IS_NEW_BACKEND_API = true

export const getTelePolicyList = async () => {
  const { salaryDeductionProfiles } = await get<{
    salaryDeductionProfiles: SalaryDeductionProfileOriginal[]
  }>(API_ROUTE_ADMIN_TELE_POLICIES, IS_NEW_BACKEND_API)

  return salaryDeductionProfiles
}
